import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsLoadingSpinner from "../icons/loading-spinner";

<template>
  <span class={{if @loading "opacity-0"}} {{mergeClasses}} ...attributes>{{yield}}</span>
  {{#if @loading}}
    <div
      class="absolute bottom-0 flex items-center justify-center left-0 right-0 top-0"
      data-test-g-button-loading-spinner
    >
      <IconsLoadingSpinner class="w-6 -ml-1 -mt-0.5" @color={{@color}} />
    </div>
  {{/if}}
</template>
